module.exports = function getResource(label) {
    let resources = {
        free: 'GRATUIT'
    };

    return resources[label];
};
